import React from 'react';
import { InputQ1Wrapper, InputLabel } from '../styles';
import TextInput from 'components/Input/TextInput';
import MultiLinearInput from '../FieldType/MultiLinearInput';
import utils from 'utils';
import actions from 'state/actions';
import { FieldInputType, FieldTriggerConfig } from 'models/response';

interface TextInputProps {
  field: any;
  helpers: any;
  multi?: boolean;
  index?: number;
  label: string;
  readonly: boolean;
  feedbackColor: string;
  hasFeedback: boolean;
  feedbackMessage: string;
  autoViewInPage: () => void;
  dispatch: any;
  fieldInputType: FieldInputType;
  name: string;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  icon: JSX.Element;
  triggerConfig: FieldTriggerConfig | null;
  executeActionQ1: () => void;
}

export const TextInputComponent: React.FC<TextInputProps> = ({
  field,
  helpers,
  multi,
  index,
  label,
  readonly,
  feedbackColor,
  hasFeedback,
  feedbackMessage,
  autoViewInPage,
  dispatch,
  fieldInputType,
  name,
  onKeyDown,
  icon,
  triggerConfig,
  executeActionQ1,
}) => {
  let value = '';
  try {
    value = multi && (index || index === 0) ? field.value.content[index].content : field.value.content[0].content;
  } catch (e) {
    console.error(e);
    utils.app.notify('warning', `Field ${name}:${label} received with a non valid value`, 5000, 'non-valid-value');
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (field.value) {
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: e && e.target.value ? e.target.value : '',
        boundingBox: { x1: -1, x2: -1, y1: -1, y2: -1 },
        pageNumber: -1,
        confidence: -1,
        status: 0,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
      if (triggerConfig) executeActionQ1();
    }
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value && field.value) {
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: e.target.value,
        status: 3,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
    }
  };

  const onFocus = () => {
    autoViewInPage();
    field.value &&
      dispatch(
        actions.documents.setFocussedQ1({
          fieldInputType,
          name,
          multi,
          index,
        }),
      );
  };

  return (
    <>
      <InputQ1Wrapper multi={multi} margin={multi ? '0 0 0 -4px' : '0'}>
        <InputLabel title={label}>{!multi ? label : ''}</InputLabel>
        {multi ? (
          <MultiLinearInput
            id={`q1-multi-text-input-${name}-${index}`}
            feedbackColor={feedbackColor}
            hasFeedback={hasFeedback}
            feedbackMessage={feedbackMessage}
            disabled={readonly}
            value={value}
            name={name}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            onBlur={(e) => handleBlur(e)}
            onChange={handleChange}
            width="160px"
            margin="0px"
            borderRadius="4px"
            typeOfField="text"
            index={index}
            values={[...field.value.content]}
            field={field}
            helpers={helpers}
          />
        ) : (
          <TextInput
            id={`q1-text-input-${name}`}
            feedbackColor={feedbackColor}
            hasFeedback={hasFeedback}
            feedbackMessage={feedbackMessage}
            disabled={readonly}
            value={value}
            name={name}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            onBlur={(e) => handleBlur(e)}
            onChange={handleChange}
            width="200px"
            margin="0px"
            borderRadius="4px"
          />
        )}
      </InputQ1Wrapper>
      {icon}
    </>
  );
};
